module.exports = __webpack_public_path__ + "static/media/marker.8a048e7d.svg";